<template>
    <div
        class="category absolute inset-x-0 bottom-8 carousel carousel-center p-4 pb-0 pt-0 space-x-4 rounded-box w-full z-50"
    >
        <div class="carousel-item" v-for="(category, index) in categories" :key="'cate-' + index">
            <button
                class="btn-outline btn btn-sm gap-2 normal-case bg-base-100"
                @click="changeCategory(category.id, category.title)"
                style="border: solid 2px"
            >
                <img :src="category.icon_url" class="inline w-5" alt="" loading="lazy" />
                {{ truncateText(category.title) }}
            </button>
        </div>
        <div class="carousel-item">
            <button
                class="btn-outline btn btn-sm gap-2 normal-case bg-base-100"
                @click="changeCategory('')"
                style="border: solid 2px"
            >
                ALL
            </button>
        </div>
    </div>
</template>

<script>
import CategoryHelper from '../mixins/Category';

export default {
    mixins: [CategoryHelper],
    props: {
        categories: {
            type: Array,
            required: true
        }
    },
    methods: {
        truncateText(text) {
            const max = 8;
            return text.length > max ? text.slice(0, max - 1) + '...' : text;
        },
        showAllCategories() {
            document.querySelector('.category_block').classList.toggle('show');
        }
    }
};
</script>
